import { combineReducers } from "redux";
import axios from "axios";
import _ from "lodash";
import { API } from "../../../../const";
import { Service } from "../../../service/service";
import { unAuthorized } from "../../../auth/Auth.ducks";
import { fetchKids } from "../../../kids/kids-list/Kids-list.ducks";
import { getInfosCreche } from "./infoCreche.ducks";

export const POST_ADD_ENFANT_PENDING = "POST_ADD_ENFANT_PENDING";
export const POST_ADD_ENFANT_REJECTED = "POST_ADD_ENFANT_REJECTED";
export const POST_ADD_ENFANT_FULFILLED = "POST_ADD_ENFANT_FULFILLED";

const loading = (state = {}, { type }) => {
  switch (type) {
    case POST_ADD_ENFANT_PENDING:
      return true;
    case POST_ADD_ENFANT_REJECTED:
    case POST_ADD_ENFANT_FULFILLED:
      return false;
    default:
      return false;
  }
};

const error = (state = {}, { type, payload }) => {
  switch (type) {
    case POST_ADD_ENFANT_PENDING:
    case POST_ADD_ENFANT_FULFILLED:
      return null;
    case POST_ADD_ENFANT_REJECTED:
      return payload;
    default:
      return null;
  }
};

const data = (state = {}, { type, payload }) => {
  switch (type) {
    case POST_ADD_ENFANT_FULFILLED:
      return _.isEmpty(payload.data) ? null : payload.data;

    default:
      return null;
  }
};

export default combineReducers({ loading, error, data });

export const postEnfantSimple = (tok, data) => {
  return (dispatch) => {
    dispatch({ type: POST_ADD_ENFANT_PENDING });
    const response = Service.post(`${API}api/enfant/creche/enfants/`, data, {
      headers: { Authorization: `Bearer ${tok}` },
    });
    response.then((res) => {
      dispatch({ type: POST_ADD_ENFANT_FULFILLED, payload: res });
      dispatch(getInfosCreche(tok));
      dispatch(fetchKids(tok));
    });
    response.catch((err) => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message });
      dispatch({ type: POST_ADD_ENFANT_REJECTED, payload: err });
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized());
      }
    });
  };
};
